module.exports = __webpack_public_path__ + "logo-orkla-denmark-footer-c47a7ea3d58461f39754de358cfbad96.svg";


//////////////////
// WEBPACK FOOTER
// ./Resources/public/static-src/images/logo-orkla-denmark-footer.svg
// module id = 57
// module chunks = 0